var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionOverrepotingFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3c5.523 0 10 4.477 10 10a9.985 9.985 0 01-3.999 8H5.999A9.985 9.985 0 012 13C2 7.477 6.477 3 12 3zm0 8a2 2 0 10.785 3.839l5.365 4.023a8.53 8.53 0 001.202-1.598l-5.369-4.026c.01-.078.017-.157.017-.238a2 2 0 00-2-2zm-8.44 1a8.69 8.69 0 00-.06 1c0 .338.022.672.06 1H6v-2H3.56zM18 12v2h2.44a8.69 8.69 0 00.06-1 8.69 8.69 0 00-.06-1H18zM6.74 6.325c-.526.415-1 .89-1.415 1.414L7.05 9.465 8.465 8.05 6.739 6.325zm8.795 1.725l1.415 1.415 1.724-1.726c-.415-.525-.89-1-1.414-1.414L15.535 8.05zM12 4.5a8.47 8.47 0 00-1 .06V7h2V4.56a8.584 8.584 0 00-1-.06z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionOverrepotingFill);
export default __webpack_public_path__ + "69c16965fe8af45aca4170aebc75ef1c.svg";
export { ForwardRef as ReactComponent };